import { render, staticRenderFns } from "./HeadingWithInfo.vue?vue&type=template&id=cb67c466&scoped=true&"
import script from "./HeadingWithInfo.vue?vue&type=script&lang=js&"
export * from "./HeadingWithInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadingWithInfo.vue?vue&type=style&index=0&id=cb67c466&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb67c466",
  null
  
)

export default component.exports